<template>
  <div
    :class="classes"
    :style="styles"
    v-bind="section ? { 'data-section': section } : {}"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'c-ct',
  props: {
    fluid: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: 'transparent'
    },
    experience: {
      type: Boolean,
      default: false
    },
    hasBorder: {
      type: Boolean,
      default: false,
    },
    borderColor: {
      type: String,
      default: '#074E8E',
    },
    borderWidth: {
      type: String,
      default: '1px'
    },
    borderRadius: {
      type: String,
      default: '5px',
    },
    twoColorBg: {
      type: Boolean,
      default: false,
    },
    firstPartColor: {
      type: String,
      default: '#02295C',
    },
    fixedSize: {
      type: Boolean,
      default: false,
    },
    section: {
      type: String,
      default: ''
    }
  },
  computed: {
    classes() {
      return [
        'ct-large',
        { 'ct-large--fluid': this.fluid },
        { 'ct-large--experience': this.experience },
        { 'ct-large--b-has-border': this.hasBorder },
        { 'ct-large--fixedTwoColorBg': this.twoColorBg && this.fixedSize },
        { 'ct-large--regularTwoColorBg': this.twoColorBg && !this.fixedSize },
      ]
    },
    styles() {
      return {
        background: !this.twoColorBg ? this.bgColor : '',
        '--firstPartColor': this.firstPartColor,
        'border-color': this.hasBorder ? this.borderColor : '',
        'border-width': this.hasBorder ? this.borderWidth : '',
        'border-radius': this.hasBorder ? this.borderRadius : ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .ct-large {
    position: relative;
    padding: 0;

    &--fluid {
      width: 100%;
      max-width: 100%;
    }

    &--experience {
      padding-top: 1.875rem;
      border: 0.0625rem solid red;

      &::before {
        content: '[ - container - ]';
        position: absolute;
        top: 0;
        font-size: 0.75rem;
      }
    }

    &--b-has-border {
      border: solid 0.0625rem $blue-03;
    }

    &--fixedTwoColorBg {
      background: linear-gradient(
        to bottom,
        var(--firstPartColor) 18.563rem,
        var(--firstPartColor) 18.563rem,
        transparent 10%,
        transparent 100%
      );

      @include screen-size("md") {
        background: linear-gradient(
          to bottom,
          var(--firstPartColor) 50%,
          var(--firstPartColor) 57%,
          transparent 50%,
          transparent 100%
        );
      }

      @include screen-size("xxl") {
        background: linear-gradient(
          to bottom,
          var(--firstPartColor) 50%,
          var(--firstPartColor) 57.5%,
          transparent 50%,
          transparent 100%
        );
      }
  }

    &--regularTwoColorBg {
      background: linear-gradient(
        to bottom,
        var(--firstPartColor) 50%,
        var(--firstPartColor) 50%,
        transparent 50%,
        transparent 100%
      );
    }
  }
</style>
